<template>
  <div>
    <div id="narrativa">
      <Narrativa/>

    </div>

    <div class="resto-inicio">
      <div class="container text m-t-3 m--b-2 a11y-simplificada-block">
        <img src="@/assets/img/base/firma_compuesta.svg" alt="Gobierno de México y Conahcyt">
        <h2 class="titular-portada m-t-3-sm m-t-4-md m-x-auto">
          Inicio

        </h2>
        <h2 class="titular-portada sub m-x-auto">
          Un capítulo del Ecosistema Nacional Informático de {{obtenerNombreEni}}
        </h2>


      </div>
      <div class="container text">
        <br>
        <br>
        <br>
        <img src="@/assets/img/planeas/LOGO-PLANEAS-CONACYT-V2.png" class="img-center"/>

        <hr>

        <p class="texto-alto">
          PLANEAS es un proyecto nacional de investigación e incidencia transversal del Pronaces de Energía y Cambio Climático que tiene como objetivo construir un repositorio integral, constantemente actualizado y abierto sobre el sistema energético mexicano con herramientas de visualización, modelado y análisis de escenarios que puedan servir como instrumento de consulta de la sociedad y para contribuir al diseño de políticas públicas para instrumentar una transición energética social y ambientalmente sustentable.
        </p>

        <p class="texto-alto">
          El proyecto consta de tres ejes principales:
        </p>

        <ul>
          <li>Consolidar y completar un sistema de bases de datos con información energética, ambiental y social;</li>
          <li>Analizar la información recopilada y presentarla por medio de una plataforma de visualización abierta a la sociedad integrada en el Ecosistema Nacional Informático de Conahcyt y con reportes periódicos;</li>
          <li>Desarrollar un modelo holístico del sistema energético y herramientas para su planificación con software libre que ayuden a los tomadores de decisión a desarrollar las políticas del sector con una visión integral, tomando en cuenta las características energéticas, restricciones ambientales y sociales, y rasgos socioeconómicos y culturales a nivel regional.</li>
        </ul>

        <hr>



        <GridLinkCoverImg class="m-t-1 m-t-2-md m-b-4-md">

          <LinkCoverImg
            :cover="`${public_path}imgs/BalanceNacionalEnergia.png`"
            :url="`${public_path}balance`"
            title="Balance energético"
            size="half-desk"/>
          <LinkCoverImg
            :cover="`${public_path}imgs/SistemaElectricoNacional.png`"
            :url="`${public_path}electricidad/generacion`"
            title="Electricidad"
            size="half-desk"/>
          <LinkCoverImg
            :cover="`${public_path}imgs/Hidrocarburos.png`"
            :url="`${public_path}hidrocarburos`"
            title="Hidrocarburos"
            size="half-desk"/>
          <LinkCoverImg
            :cover="`${public_path}imgs/Biomasa.png`"
            :url="`${public_path}biomasa`"
            title="Biomasa"
            size="half-desk"/>
        </GridLinkCoverImg>
      </div>
    </div>

  </div>
</template>

<script>
import GridLinkCoverImg from '@/components/base/GridLinkCoverImg.vue';
import LinkCoverImg from '@/components/base/LinkCoverImg.vue';
import Narrativa from '@/components/portada/Narrativa.vue';
import { mostrarLoader } from '@/components/_utils.js'

export default {
  name: 'Inicio',
  components: {
    GridLinkCoverImg,
    LinkCoverImg,
    Narrativa
  },
  mounted(){
    mostrarLoader()

  },
  data() {
    return {
      domain: process.env.VUE_APP_ENI_DOMAIN,
      base_route: process.env.VUE_APP_BASE_ROUTE,
      public_path: process.env.BASE_URL
    };
  },
  computed: {
    obtenerNombreEni() {
      return this.$store.getters.obtenerNombreEni;
    },
  },
};
</script>


<style lang="scss">

.resto-inicio{
  background: #fff;
}
</style>
